import React, {memo} from 'react';
import FormikTextField from 'components/inputs/FormikTextField';
import {Grid} from '@mui/material';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import Button from 'components/Button';
import {useTranslation} from 'react-i18next';
import {useFormContext} from 'react-hook-form';
import {GridCentered} from 'components/GridCentered';

const _validationSchema = yup.object({
   email: yup.string().required(),
});
type SendEmailFormType = {email: string}; // yup.InferType<typeof _validationSchema>;

interface SendEmailFormProps {
   // label: string;
   value?: string;
   validationSchema?: typeof _validationSchema;
   onSubmit: (
      nameObj: SendEmailFormType,
      callbacks: FormOnSubmitHelpers<SendEmailFormType>
   ) => void;
}
export const SendEmailForm = memo(
   ({
      value,
      onSubmit,
      // label,
      validationSchema = _validationSchema,
   }: SendEmailFormProps) => {
      // const onClose = React.useCallback(() => onSubmit(), [onSubmit]);
      return (
         <Formik
            initialValues={validationSchema.cast({email: value})}
            initialTouched={Boolean(value) ? ['email'] : undefined}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
         >
            <Form />
         </Formik>
      );
   }
);

const Form = ({}: // label,
// cancel,
{
   // label: string;
   // cancel: () => void;
}) => {
   const {t} = useTranslation();
   const {
      formState: {isSubmitting, isDirty, touchedFields},
   } = useFormContext();

   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <GridCentered item xs={3}>
               {t('Send Test Email: ')}
            </GridCentered>
            <GridCentered item sm={5}>
               <FormikTextField
                  autoFocus
                  type="email"
                  name="email"
                  // label={label}
                  placeholder="test@domain.com"
               />
            </GridCentered>
            <GridCentered item xs={3}>
               <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isSubmitting || (!isDirty && !touchedFields)}
                  // disabled={!value.trim()}
               >
                  {t('Send Email')}
               </Button>
            </GridCentered>
         </Grid>
         {/* <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <Button onClick={cancel} color="inherit">
                  {t('Close')}
               </Button>
            </Grid>
         </Grid> */}
      </>
   );
};
